import {
  bgremoveExamples,
  colorizeExamples,
  enhancerExamples,
  enlargerExamples
} from './data'
export const tools = {
  BgRemove: 'bgremove',
  ImageColorizer: 'colorize',
  ImageEnhaner: 'enhancer',
  ImagerConverter: 'converter',
  ImageCompressor: 'compressor',
  ResolutinEnlarger: 'enlarger',
  ImageEditor: 'editor',
  ImageResizer: 'resize',
  ImageFlipper: 'flip',
  ImageRotater: 'rotate'
}

//当前工具标题
export const toolTitleMap = new Map([
  [tools.BgRemove, `<span>Upload images to<br/> remove the background</span>`],
  [tools.ImageColorizer, `<span>Upload back & white<br/> images to colorize</span>`],
  [tools.ImageEnhaner, `<span>Upload images to<br/> enhance the quality</span>`],
  [tools.ResolutinEnlarger, `<span>Upload images to<br/> enlarge the resolutions</span>`],
  [tools.ImagerConverter, `<span>Upload and Convert<br/> Images in Batch</span>`],
  [tools.ImageCompressor, `<span>Upload and Compress<br/> Images in Batch</span>`],
  [tools.ImageEditor, `<span>ImageEditor</span>`],
  [tools.ImageResizer, `<span>Upload and Resize<br/> Images in Batch</span>`],
  [tools.ImageFlipper, `<span>Upload and Flip<br/> Images in Batch</span>`],
  [tools.ImageRotater, `<span>Upload and Rotate<br/> Images in Batch</span>`],
])

//当前工具详情
export const toolDetailMap = new Map([
  [tools.BgRemove, 'bgRemoveDetail'],
  [tools.ImageColorizer, 'colorizeDetail'],
  [tools.ImageEnhaner, 'enhancerDetail'],
  [tools.ResolutinEnlarger, 'enlargerDetail'],
  [tools.ImagerConverter, 'converterDetail'],
  [tools.ImageCompressor, 'compressorDetail'],
])

//当前工具上传的图片数组
export const toolImagesMap = new Map([
  [tools.BgRemove, 'bgRemoveImages'],
  [tools.ImageColorizer, 'colorizeImages'],
  [tools.ImageEnhaner, 'enhancerImages'],
  [tools.ResolutinEnlarger, 'enlargerImages'],
  [tools.ImagerConverter, 'converterImages'],
  [tools.ImageCompressor, 'compressorImages'],
])

// 当前工具展开项的数组
export const toolActivesMap = new Map([
  [tools.BgRemove, 'bgRemoveActives'],
  [tools.ImageColorizer, 'colorizeActives'],
  [tools.ImageEnhaner, 'enhancerActives'],
  [tools.ResolutinEnlarger, 'enlargerActives'],
  [tools.ImagerConverter, 'converterActives'],
  [tools.ImageCompressor, 'compressorActives'],
])

export const toolExamplePictures = new Map([
  [tools.BgRemove, bgremoveExamples],
  [tools.ImageColorizer, colorizeExamples],
  [tools.ImageEnhaner, enhancerExamples],
  [tools.ResolutinEnlarger, enlargerExamples]
])

// private tools
export const privateTools = [
  tools.BgRemove,
  tools.ImageColorizer,
  tools.ImageEnhaner,
  tools.ResolutinEnlarger,
  // tools.ImagerConverter,
  // tools.ImageCompressor,
]

export const toolItemMap = new Map([
  [tools.BgRemove, 'bgremoveItem'],
  [tools.ImageColorizer, 'colorizeItem'],
  [tools.ImageEnhaner, 'enhancerItem'],
  [tools.ResolutinEnlarger, 'enlargerItem'],
  [tools.ImagerConverter, 'convertetItem'],
  [tools.ImageCompressor, 'compressorItem'],
  [tools.ImageEditor, 'editorItem'],
  [tools.ImageFlipper, 'flipItem'],
  [tools.ImageRotater, 'rotateItem'],
  [tools.ImageResizer, 'resizeItem']
])


export const sToolTitleMap = new Map([
  [tools.BgRemove, 'BGRemover'],
  [tools.ImageColorizer, 'ImageColorizer'],
  [tools.ImageEnhaner, 'Color Enhancer'],
  [tools.ResolutinEnlarger, 'Resolution Enlarger'],
  [tools.ImagerConverter, 'ImageConverter'],
  [tools.ImageCompressor, 'ImageCompressor'],
  [tools.ImageEditor, 'ImageEditor'],
  [tools.ImageResizer, 'ImageResizer']
])

export const toolSupportFormatMap = new Map([
  [tools.BgRemove, ['JPG', 'JPEG', 'PNG', 'BMP', 'WEBP']],
  [tools.ImageColorizer, ['JPG', 'JPEG', 'PNG', 'BMP', ]],
  [tools.ImageEnhaner, ['JPG', 'PNG', 'BMP', ]],
  [tools.ResolutinEnlarger, ['JPG', 'JPEG', 'BMP', 'PNG', 'WEBP']]
])

export const toolFileLimitMap = new Map([
  [tools.BgRemove, {
    format: ['JPG', 'JPEG', 'PNG', 'BMP', 'WEBP'],
    lpx: {
      w: 0,
      h: 0
    },
    spx: {
      w: 32,
      h: 32
    },
    lsz: 40
  }],
  [tools.ImageColorizer, {
    format: ['JPG', 'JPEG', 'PNG', 'BMP'],
    lpx: {
      w: 3000,
      h: 3000
    },
    spx: {
      w: 0,
      h: 0
    },
    lsz: 10
  }],
  [tools.ImageEnhaner, {
    format: ['JPG', 'PNG', 'BMP'],
    lpx: {
      w: 3840,
      h: 3840
    },
    spx: {
      w: 360,
      h: 360
    },
    lsz: 3
  }],
  [tools.ResolutinEnlarger, {
    format: ['JPG', 'JPEG', 'BMP', 'PNG', 'WEBP'],
    lpx: {
      w: 1920,
      h: 1080
    },
    spx: {
      w: 32,
      h: 32
    },
    lsz: 3
  }]
])
